"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationEditor = exports.TranslationCountIcon = exports.TranslationCount = exports.TranslationEditorGridContainer = exports.MessageContainer = exports.TranslationEditorContainer = exports.defaultColumns = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var EditableTable_1 = require("@aon/aon-tws-common-ui/build/lib/components/EditableTable");
var React = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var styled_components_1 = __importDefault(require("styled-components"));
var contentConstants_1 = __importDefault(require("../../contentConstants"));
var TranslationHelper_1 = require("../../utilities/TranslationHelper");
exports.defaultColumns = [
    { columnKey: 'cultureName', label: 'Language', editable: false },
    {
        columnKey: 'text',
        label: 'Translation',
        editable: true,
        placeholder: 'Translation text',
        requiredMessage: contentConstants_1.default.ERROR_MISSING_TRANSLATION,
        type: 'textarea',
        minHeight: '150px',
        maxWidth: '720px',
    },
    { columnKey: 'modifiedOn', label: 'Updated', editable: false, dataType: 'date' },
];
exports.TranslationEditorContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 100%;\n\t&& input:-ms-input-placeholder {\n\t\tcolor: #999 !important;\n\t}\n\t&& textarea:-ms-input-placeholder {\n\t\tcolor: #999 !important;\n\t}\n\t& .tws-editable-column {\n\t\tword-break: break-all;\n\t}\n\n\t@media (max-width: 795px) {\n\t\toverflow-x: scroll;\n\t}\n"], ["\n\twidth: 100%;\n\t&& input:-ms-input-placeholder {\n\t\tcolor: #999 !important;\n\t}\n\t&& textarea:-ms-input-placeholder {\n\t\tcolor: #999 !important;\n\t}\n\t& .tws-editable-column {\n\t\tword-break: break-all;\n\t}\n\n\t@media (max-width: 795px) {\n\t\toverflow-x: scroll;\n\t}\n"])));
exports.MessageContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\twidth: 100%;\n\n\t@media (max-width: 795px) {\n\t\tpadding: 5px 0;\n\t}\n"], ["\n\twidth: 100%;\n\n\t@media (max-width: 795px) {\n\t\tpadding: 5px 0;\n\t}\n"])));
// editor grid
exports.TranslationEditorGridContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t", "\n\n\twidth: 100%;\n\n\t.tws-editable-table {\n\t\tborder: 1px solid #999999;\n\t\tfont-size: 13px;\n\t}\n\t.tws-editable-table .tws-editable-head {\n\t\tfont-weight: 600;\n\t\theight: 40px;\n\t}\n\t.tws-editable-table .tws-editable-column:nth-child(1) {\n\t\t", "\n\t\twidth: 25%;\n\t}\n\t.tws-editable-table .tws-editable-column:nth-child(2) {\n\t\t", "\n\t\tpadding-bottom: 0;\n\t}\n\t.tws-editable-table .tws-editable-column:nth-child(3) {\n\t\twidth: 15%;\n\t}\n\t.tws-editable-table .tws-editable-row .tws-editable-column,\n\t.tws-editable-table .tws-editable-row .tws-editable-headcolumn {\n\t\tborder: 1px solid #999999;\n\t}\n\t.tws-editable-table .tws-editable-row textarea,\n\t.tws-editable-table .tws-editable-row input {\n\t\tcolor: #444444;\n\t}\n"], ["\n\t", "\n\n\twidth: 100%;\n\n\t.tws-editable-table {\n\t\tborder: 1px solid #999999;\n\t\tfont-size: 13px;\n\t}\n\t.tws-editable-table .tws-editable-head {\n\t\tfont-weight: 600;\n\t\theight: 40px;\n\t}\n\t.tws-editable-table .tws-editable-column:nth-child(1) {\n\t\t", "\n\t\twidth: 25%;\n\t}\n\t.tws-editable-table .tws-editable-column:nth-child(2) {\n\t\t", "\n\t\tpadding-bottom: 0;\n\t}\n\t.tws-editable-table .tws-editable-column:nth-child(3) {\n\t\twidth: 15%;\n\t}\n\t.tws-editable-table .tws-editable-row .tws-editable-column,\n\t.tws-editable-table .tws-editable-row .tws-editable-headcolumn {\n\t\tborder: 1px solid #999999;\n\t}\n\t.tws-editable-table .tws-editable-row textarea,\n\t.tws-editable-table .tws-editable-row input {\n\t\tcolor: #444444;\n\t}\n"])), function (props) {
    return props.unStyledContainer
        ? ''
        : "\tbackground-color: #EDF4F7;\n\t\t\tpadding: 30px 30px 60px 30px;";
}, function (props) { return (props.highlightCell1Border ? 'border: 2px solid #000000!important;' : ''); }, function (props) { return (props.highlightCell2Border ? 'border: 2px solid #000000!important;' : ''); });
exports.TranslationCount = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\theight: 30px;\n"], ["\n\theight: 30px;\n"])));
exports.TranslationCountIcon = (0, styled_components_1.default)(aon_tws_common_ui_1.Icon)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tmargin-right: 5px;\n"], ["\n\tmargin-right: 5px;\n"])));
var TranslationEditor = /** @class */ (function (_super) {
    __extends(TranslationEditor, _super);
    function TranslationEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnPaste = function (e) {
            var hasDefaultTranslation = _this.props.hasDefaultTranslation;
            var preventPastingOverride = ['INPUT', 'TEXTAREA'];
            if (hasDefaultTranslation && preventPastingOverride.indexOf(e.target.tagName.toLowerCase()) === -1) {
                var clipboardData = e.clipboardData.getData('text/html');
                var translations = TranslationHelper_1.TranslationHelper.mapHTMLToTranslationData(_this.props.translations, clipboardData);
                if (translations.length) {
                    _this.handleOnUpdate(lodash_1.default.orderBy(translations, ['cultureName', 'cultureCode']));
                }
            }
        };
        _this.onUpdate = function (data, deletedUniqueIds, event) {
            var onChange = _this.props.onChange;
            _this.setState({ translationCount: data.length }, function () {
                if (onChange) {
                    onChange(data, deletedUniqueIds, event);
                }
            });
        };
        _this.onError = function (records) {
            var onError = _this.props.onError;
            if (onError) {
                onError(records);
            }
        };
        _this.state = {
            columns: props.columns || __spreadArray([], exports.defaultColumns, true),
            translations: props.translations,
            translationCount: props.translations ? props.translations.length : 0,
        };
        _this.handleOnUpdate = _this.handleOnUpdate.bind(_this);
        _this.finishUpdate = _this.finishUpdate.bind(_this);
        return _this;
    }
    TranslationEditor.getDerivedStateFromProps = function (props, state) {
        if (!lodash_1.default.isEqual(props.translations, state.translations)) {
            var translationCount = props.translations ? props.translations.length : 0;
            return { translations: props.translations, translationCount: translationCount };
        }
        return {};
    };
    TranslationEditor.prototype.componentDidMount = function () {
        var inputType = this.props.inputType;
        if (inputType === 'input') {
            var columnsForInputType = exports.defaultColumns.map(function (c) { return (__assign(__assign({}, c), { type: c.type ? inputType : undefined })); });
            this.setState({ columns: columnsForInputType });
        }
    };
    TranslationEditor.prototype.render = function () {
        var _a = this.props, defaultLanguage = _a.defaultLanguage, defaultTranslationRequiredText = _a.defaultTranslationRequiredText, deleteAllIcon = _a.deleteAllIcon, deleteColumn = _a.deleteColumn, duplicateFields = _a.duplicateFields, duplicatedRecords = _a.duplicatedRecords, editMode = _a.editMode, emptyRow = _a.emptyRow, hasDefaultTranslation = _a.hasDefaultTranslation, invalidFields = _a.invalidFields, property = _a.property, propertyDisplayName = _a.propertyDisplayName, requireFields = _a.requireFields, translations = _a.translations, typeAheadDisplayRenderer = _a.typeAheadDisplayRenderer, typeAheadOptions = _a.typeAheadOptions, existingEditable = _a.existingEditable;
        var _b = this.state, columns = _b.columns, translationCount = _b.translationCount;
        return (React.createElement(exports.TranslationEditorContainer, { className: 'tws-translation-editor-container', onPaste: this.handleOnPaste }, hasDefaultTranslation ? (React.createElement(exports.TranslationEditorGridContainer, { unStyledContainer: this.props.unStyledContainer, highlightCell1Border: this.props.highlightCell1Border, highlightCell2Border: this.props.highlightCell2Border },
            React.createElement(exports.TranslationCount, { className: 'tws-translation-count' },
                React.createElement(exports.TranslationCountIcon, { name: 'total' }),
                translationCount),
            React.createElement(EditableTable_1.EditableTable, { id: "translation-editor-".concat(property), columns: columns, isDefault: false, defaultCode: defaultLanguage, buttons: false, emptyRow: emptyRow, editMode: editMode, deleteAllIcon: deleteAllIcon, deleteColumn: deleteColumn, requireFields: requireFields, duplicateFields: duplicateFields, invalidFields: invalidFields, typeAheadDisplayRenderer: function (record) {
                    return typeAheadDisplayRenderer ? (typeAheadDisplayRenderer(record)) : (React.createElement("div", null,
                        record.code,
                        " ",
                        record.text));
                }, typeAheadOptions: typeAheadOptions, data: translations.map(function (t, uniqueId) { return (__assign(__assign({}, t), { uniqueId: uniqueId })); }), duplicatedRecords: duplicatedRecords, onError: this.onError, onUpdate: this.onUpdate, validateRequiredOnSave: false, responsive: false, existingEditable: existingEditable }))) : (React.createElement(exports.MessageContainer, null, defaultTranslationRequiredText ||
            contentConstants_1.default.TRANSLATIONS_DEFAULT_TRANSLATION_REQUIRED.replace('{property}', propertyDisplayName.toLowerCase())))));
    };
    TranslationEditor.prototype.handleOnUpdate = function (translations) {
        var nextTranslations = TranslationHelper_1.TranslationHelper.updateTranslationEditState(translations, this.props.translations);
        this.finishUpdate(nextTranslations);
    };
    TranslationEditor.prototype.finishUpdate = function (translations) {
        var onChange = this.props.onChange;
        onChange(translations);
    };
    return TranslationEditor;
}(React.Component));
exports.TranslationEditor = TranslationEditor;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
